<div class="row mb-3">
	<div class="col-xs-12 col-md-12">
		<div class="row mb-3">
			<div class="col-12">
				<form class="d-flex align-items-center">
						<label jhiTranslate="pedigree.tree.number.of.steps.backward">Number of Steps Backward</label>
                        <div class="col-1">
                            <select [disabled]="isLoading" class="ms-1 form-select" name="numberOfStepsBackward" [(ngModel)]="numberOfStepsBackward" (change)="numberOfStepsChanged()">
                                <option *ngFor="let numberOfStep of numberOfSteps" [value]="numberOfStep">{{numberOfStep}}</option>
                            </select>
                        </div>
						<label class="ms-3"jhiTranslate="pedigree.tree.number.of.steps.forward">Number of Steps Forward</label>
                        <div class="col-1">
                            <select [disabled]="isLoading" class="ms-1 form-select" name="numberOfStepsBackward" [(ngModel)]="numberOfStepsForward" (change)="numberOfStepsChanged()">
                                <option *ngFor="let numberOfStep of numberOfSteps" [value]="numberOfStep">{{numberOfStep}}</option>
                            </select>
                        </div>

				</form>
			</div>
		</div>
		<div class="table-responsive pt-3 custom-scroll-style" style="max-height: 400px; overflow-y: auto; overflow-x: auto;">
			<p-tree *ngIf="!isLoading else loading" [value]="nodes" autolayout="true"
					styleClass="tree-table">
				<ng-template pTemplate="default" let-node>
					<a [href]="this.germplasmDetailsUrlService.getUrl(node.data.id)" target="_blank"><span *jhiHasAnyAuthority="VIEW_NAMES_PERMISSION"><truncate-span [textInput]="node.data.name" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></span> ({{node.data.id}})</a>
				</ng-template>
			</p-tree>
			<ng-template #loading>
				<div class="ui-tree d-flex align-items-center justify-content-center"><span class="throbber"></span></div>
			</ng-template>
		</div>
	</div>
</div>
